// A stored media reference is either a numeric media_id (the new media
// system) or a legacy URL string baked in before the migration. These
// helpers let consumers take the dual-path: resolve a media_id at render,
// or use a legacy URL directly.

export function mediaIdFromValue(value) {
  if (typeof value === "number" && value > 0) {
    return value;
  }
  if (typeof value === "string" && /^[0-9]+$/.test(value)) {
    return Number(value);
  }
  return null;
}

export function isMediaId(value) {
  return mediaIdFromValue(value) !== null;
}

export function isLegacyUrl(value) {
  return typeof value === "string" && value !== "" && mediaIdFromValue(value) === null;
}
